<template>
    <div>
            <div class="heading-travel-policy">
                <span :class="classOfServiceObj.isActive?'tag is-success':'tag'">Standard</span> 

                <div class="right-content">
                    <div class="lefttext">
                        <p class="paragrapgh">Class of service</p>
                        <p>Trigger for any flight where the class of service is:
                        
                            <span class="rule-config-variable" @click="isEdit = !isEdit">
                                <span v-for="(res,i) in classOfServiceObj.value" :key="i">
                                    {{res.key?res.value:$helpers.getAirClassLabel(res)+','}}
                                </span>
                                <b-icon icon="pencil" size="is-small" ></b-icon> 
                            </span>
                        </p>

                    </div>
                    <div class="allbtns">
                        
                        <b-switch 
                            :rounded="true" 
                            :value="classOfServiceObj.isActive" 
                            v-model="classOfServiceObj.isActive"
                            @input="flightClassOfService" 
                            
                            >
                        </b-switch>
                    </div>
                </div>
            </div>
            <div v-if="isEdit" class="edittravelpolicy2">
                <AirClassOfService @classOfServices="getValue" :classOfSer="classOfServiceObj.value"/>
                <p>Select class of service</p>
                <b-button @click="saveCall">SAVE</b-button>
            </div>
    </div>
</template>
<script>
import AirClassOfService from '../CommonRules/AirClassOfService.vue';
export default{
    name:"ClassOfService",
    components:{AirClassOfService},
    props: {
    value: {
      type: [Object],
    },
  },
    data(){
        return{
            classOfServiceObj : {
                    name: "flightClassOfService",
                    isActive: false,
                   // value: [{key:'Y',value:'Economy'}]
                   value:['Y']
            },
            isEdit : false,
            emitedValue : []
        }
    },
    
    methods:{
        saveCall(){
            this.isEdit = false;
            if(this.emitedValue || this.emitedValue=='') {
              this.classOfServiceObj.value = this.emitedValue;
              this.filterKeyOfService(this.classOfServiceObj)
            }
        },
        getValue(val) {
          this.emitedValue = val;
        },

       filterKeyOfService(data){
        let obj = JSON.parse(JSON.stringify(data));
        obj.value.forEach((e,i)=>{
            console.log(e);
            if(e.key!=null){
                obj.value[i] = e.key;
            }
             else
             obj.value[i] = e

        })
        this.$emit('flightClassOfService',obj)
       },

        flightClassOfService(){
            this.classOfServiceObj.message=this.buildMessage;
            this.filterKeyOfService(this.classOfServiceObj)
        }
    },
    mounted() {
        this.classOfServiceObj.type='air';
        this.classOfServiceObj.message=this.buildMessage;

        this.filterKeyOfService(this.classOfServiceObj)
    },
    computed:{
        buildMessage(){

            var string ='Trigger for any flight where the class of service is ';

            return string + (this.classOfServiceObj.value?this.classOfServiceObj.value.join():'N/A');
        }
    },
    watch: {
    value: {
      handler(newVal, prevVal) {
        this.classOfServiceObj = this.value;
        this.classOfServiceObj.type='air';
        this.classOfServiceObj.message=this.buildMessage;
        this.filterKeyOfService(this.classOfServiceObj)

      },
      deep: true,
    },
  },

}
</script>